<template>
  <div class="content">
    <h1 class="content-title">Login</h1>
    <div id="firebaseui-auth-container" class="mt-20"></div>
    <div id="loader">Loading...</div>
  </div>
</template>

<script>
import { firebase, auth } from "../../lib/firebase.js";
const firebaseui = require("firebaseui");
const ui = new firebaseui.auth.AuthUI(firebase.auth());

export default {
  name: "LoginComponent",
  components: {},
  data() {
    return {};
  },
  mounted() {
    let params = new URLSearchParams(document.location.search.substring(1));
    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: (/* authResult, redirectUrl */) => {
          return true;
        },
        uiShown: function() {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById("loader").style.display = "none";
        },
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: "popup",
      signInSuccessUrl: params.get("redirect") ? params.get("redirect") : "/",
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          signInMethod:
            firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
          emailLinkSignIn: function() {
            return {
              // Additional state showPromo=1234 can be retrieved from URL on
              // sign-in completion in signInSuccess callback by checking
              // window.location.href.
              url: `${document.location.origin}/login`,
            };
          },
        },
      ],
      // Terms of service url.
      tosUrl: "/tos",
      // Privacy policy url.
      privacyPolicyUrl: "/privacy",
    };

    ui.start("#firebaseui-auth-container", uiConfig);
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit("setAuthenticated", true);
        this.$store.commit("setUser", user);
        window.analytics.identify(user.uid, {
          name: user.displayName,
          email: user.email,
        });
      } else {
        this.$store.commit("setAuthenticated", false);
        this.$store.commit("setUser", null);
      }
      this.authChecked = true;
    });
  },
  methods: {
    login: async function() {},
    logout: function() {
      firebase.auth().signOut();
    },
  },
};
</script>
